import React from "react"
import { Box } from '@sqymagma/elements'


export default({dayNumber, monthNumber}) => {
  return (
    <Box width={1} textAlign="center" my="m">
      <img src={`/svg/datamodule-eu/${dayNumber}-${monthNumber}-letalidad-eu.svg`} alt={`Tasa de letalidad en principales países Europeos (EU) por covid-19 ${dayNumber}-${monthNumber}-2020`} />
    </Box>
  )
}

